import * as React from 'react'
import { useState } from 'react'
import { actionCreators } from '../../actions'
import { useDispatch, useSelector } from 'react-redux'
import { Model } from '../../types/types'
import { ClientCode, ClientConfig, ClientForm } from '../../types/clients'

export default function ClientsList(props: {
  clientConfigs: ReadonlyArray<ClientConfig>
  clientForms: ReadonlyArray<ClientForm>
  setAddingClient: (value: boolean) => void
}) {
  const [clientCodeSearchTerm, setClientCodeSearchTerm] = useState<string>('')
  const selectedClientCode = useSelector<Model, string | undefined>(
    (s) => s.selectedClientCode,
  )
  const dispatch = useDispatch()

  function deselectClient(selectedClient: string | undefined): JSX.Element {
    if (selectedClient === undefined) {
      return <></>
    }
    return (
      <button
        type='button'
        onClick={() => {
          props.setAddingClient(false);
          dispatch(actionCreators.selectClient(undefined))
        }}
        className={'button button--full_width'}
      >
        <em>Clear selection</em>
      </button>
    )
  }

  function renderSelector(
    clientConfig: ClientConfig,
    clientForm: ClientForm | undefined,
    isActive: boolean,
  ): JSX.Element {
    const code: ClientCode = clientConfig.code
    return (
      <button
        type='button'
        key={code}
        onClick={(event) => {
          props.setAddingClient(false);
          const action = actionCreators.selectClient(event.currentTarget.value);
          dispatch(action);
        }}
        value={code}
        className={
          'button button--full_width ' +
          (code === selectedClientCode ? 'button--active' : '') +
          (isActive ? '' : ' button--inactive')
        }
      >
        {code}
        {clientForm &&
        clientForm.code === clientConfig.code &&
        clientForm.saveState === 'Dirty' ? (
          <span title='Unsaved Changes'>*</span>
        ) : (
          <></>
        )}
      </button>
    )
  }

  return (
    <>
      <input
        className="input no-margin-top full-width"
        placeholder="Search"
        onChange={(event) => setClientCodeSearchTerm(event.currentTarget.value)}
      />

      <button
        className="button button--full_width"
        onClick={() => props.setAddingClient(true)}
      >
        Add Client
      </button>

      {deselectClient(selectedClientCode)}

      <div className='margin-bottom-1em' />

      {/* ---- Active Clients ---- */}
      {props.clientConfigs
        .filter((c) => c.isActive && c.code.includes(clientCodeSearchTerm))
        .map((c) =>
          renderSelector(
            c,
            props.clientForms.find((f) => f.originalClientCode === c.code),
            true,
          ),
        )}

      <div className="margin-bottom-1em" />

      {/* ---- Inactive Clients ---- */}
      <h5 className="margin-top-1-em margin-bottom-0_5em">
        Inactive Clients: {props.clientConfigs.filter(c => !c.isActive).length}
      </h5>

      <div className="clients-list-inactive-container">
        {props.clientConfigs
          .filter((c) => !c.isActive && c.code.includes(clientCodeSearchTerm))
          .map((c) =>
            renderSelector(
              c,
              props.clientForms.find((f) => f.originalClientCode === c.code),
              false,
            ),
          )}
      </div>
    </>
  );
}
